import { Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";
import * as COMS from "../../constants/comsTypes";

const CommsForm = ({ config, setConfig, setErrorComms, errorComms, version, groupData }) => {
  const { t } = useTranslation();

  const onCommsChange = (e, key) => {
    const newValue = e.target.value;

    setConfig((prevConfig) => {
        if(key === 'alert_mode'){
            return {
                ...prevConfig,
                device_setting: {
                    ...prevConfig?.device_setting,
                    misc: {
                        ...prevConfig?.misc,
                        alert_mode: newValue
                    }
                }
            }
        }
        return {
            ...prevConfig,
            device_setting: {
                ...prevConfig?.device_setting,
                misc: {
                    ...prevConfig?.device_setting?.misc,
                    transmission_mode : {
                        ...prevConfig?.device_setting?.misc?.transmission_mode,
                        [key] : newValue
                    }
                }
            }
        }
    });
  }

  const buildPriorityList = () => {
    let list = [{ key: 0, value: t("common.off") }];
    groupData?.comsTypes?.includes(COMS.SIGFOX) && list.push({ key: 1, value: t("devices.setUp.trans_mode.priority.sigfox_only") });
    groupData?.comsTypes?.includes(COMS.SIGFOX) && groupData?.comsTypes?.includes(COMS.WIFI) && list.push({ key: 2, value: t("devices.setUp.trans_mode.priority.sigfox_first") });
    groupData?.comsTypes?.includes(COMS.WIFI) && list.push({ key: 3, value: t("devices.setUp.trans_mode.priority.wifi_only") });
    groupData?.comsTypes?.includes(COMS.SIGFOX) && groupData?.comsTypes?.includes(COMS.WIFI) && list.push({ key: 4, value: t("devices.setUp.trans_mode.priority.wifi_first") });
    return list;
  }

  return (<>
    {version >= 210 && !groupData?.comsTypes?.includes(COMS.STANDALONE) && (
        <Grid item xs={12}>
        <Typography
            color="secondary"
            style={{
            fontWeight: 500,
            fontSize: 22,
            lineHeight: "30px",
            marginTop: 18,
            }} >
            {t(`devices.setUp.comms.title`)}
        </Typography>
        </Grid>
    )}

    {version >= 210 && (groupData?.comsTypes?.includes(COMS.SIGFOX) || groupData?.comsTypes?.includes(COMS.WIFI)) && (
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
            label={t("device.details.config.misc.trans_mode.priority")}
            value={config?.device_setting?.misc?.transmission_mode?.priority}
            onChange={(e) => onCommsChange(e, 'priority')}
            kv
            values={(() => buildPriorityList())()} />
        </Grid>)}
    
    {version >= 210 &&
        config?.device_setting?.misc?.transmission_mode?.priority >= 3 /* solo se permite para los que tengan prioridad wiifi, ya que paras las demás opciones no se puede elegir*/ && (
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <SelectConfig
                label={t("device.details.config.misc.trans_mode.transmit_frequency")}
                value={config?.device_setting?.misc?.transmission_mode?.transmit_frequency}
                onChange={(e) => onCommsChange(e, 'transmit_frequency')}
                kv values={[
                    { key: 0, value: t("devices.setUp.trans_mode.frequency.send_everyday") },
                    { key: 1, value: t("devices.setUp.trans_mode.frequency.send_4_30_days") },
                    { key: 2, value: t("devices.setUp.trans_mode.frequency.send_1_30_days") },]} />
        </Grid>)}

    {version >= 210 && config?.device_setting?.misc?.transmission_mode?.priority >= 1 && (
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <SelectConfig
            label={t("device.details.config.misc.trans_mode.gps_enable")}
            value={config?.device_setting?.misc?.transmission_mode.gps_enable}
            onChange={(e) => onCommsChange(e, 'gps_enable')}
            kv values={[
                { key: 0, value: t("devices.setUp.alerts.off") },
                { key: 1, value: t("devices.setUp.alerts.on") },]} />
        </Grid>)}
  </>);
};

export default CommsForm;